import React from 'react'
import { Props } from './types'
import { LabeledFormSectionContainer, LightTableContainer, LightTableLineContainer, Icon } from 'components/common'
import styles from './ShippingsSection.module.scss'
import { icons } from 'assets'

const ShippingsSection = ({ shippings = [] }: Props) => {
  const renderTitle = () => {
    return (
      <>
        <div className={styles.name}>Name</div>
        <div className={styles.currency}>Currency</div>
        <div className={styles.price}>Price</div>
      </>
    )
  }

  return (
    <LabeledFormSectionContainer label='Shippings'>

      {shippings.length
        ? <LightTableContainer title={renderTitle()}>

          {shippings.map(({ id, name, currency, price }) =>
            <LightTableLineContainer key={id}>
              <div className={styles.lineName}>{name}</div>
              <div className={styles.lineCurrency}>{currency}</div>
              <div className={styles.linePrice}>{price}</div>
            </LightTableLineContainer>
          )}

        </LightTableContainer>
        : <div className={styles.info}>
          <Icon icon={icons.info} /> no shipping data
        </div>
      }

    </LabeledFormSectionContainer>
  )
}

export default ShippingsSection
